import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';
import { f as fetchHTML } from './fetchHTML-CGNR3V1z.js';
import './parseHTML-Om2c1Ayj.js';

class ProductVariantSelect extends HTMLElement {
  #abortController;
  #url = this.dataset.url;
  #sectionId = this.dataset.sectionId;
  #productId = this.dataset.productId;

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = event.target.closest('[data-variant-id]');
      if (target && !this.#abortController) this.#handleVariantChange({ target });
    });
  }

  /**
   * Handle variant change
   * @param {Event} event - The event object
   */
  async #handleVariantChange({ target }) {
    if (this.#abortController) return;
    this.#abortController = new AbortController();

    const { variantId } = target.dataset;
    const params = this.#createParams(variantId);

    try {
      PubSub.publish('variant:changing', { id: this.#productId });
      const html = await fetchHTML(`${this.#url}?${params}`, {
        signal: this.#abortController.signal,
      });

      PubSub.publish('variant:change', {
        id: this.#productId,
        data: { html },
      });

      this.#updateURL(variantId);
    } catch (error) {
      console.error('Error handling variant change:', error);
    } finally {
      this.#abortController = null;
      document.querySelector(`#${target.id}`).focus();
    }
  }

  /**
   * Update the URL with the new variant ID
   * @param {string} variantId - The variant ID
   */
  #updateURL(variantId) {
    const { searchParams } = new URL(window.location);
    searchParams.set('variant', variantId);
    history.replaceState(null, '', `${window.location.pathname}?${searchParams}`);
  }

  /**
   * Create the parameters for the URL
   * @param {string} variantId - The variant ID
   * @returns {string} The parameters
   */
  #createParams(variantId) {
    return [`section_id=${this.#sectionId}`, `variant=${variantId}`].join('&');
  }
}

customElements.define('product-variant-select', ProductVariantSelect);
